import './App.css';
import Book from './Components/Book/Book';
import MainPage from './Components/MainPage/MainPage';
import Navbar from './Components/Navbar/Navbar';
import {BrowserRouter as Router, Routes,Route} from "react-router-dom"
import Payments from './Components/Payments/Payments';
function App() {

return (
  <Router>
     <Navbar/>
    <Routes>
    <Route
      element={<MainPage />}
      path="/"
      
    />
    <Route
      element={<Book/>}
      path="/:id/select-seats"
    />
    <Route
      element={<Payments/>}
      path="/:id/payments"
    />
   
    
    </Routes>
  </Router>
    
   

  
  );
}

export default App;
